import { Navigate, useNavigate, useParams } from 'react-router-dom'

import {
  FBPageInnerTabsContainer,
  FBPageTableContainer,
} from 'components/FbUI/Page/styles'
import { Tabs } from 'components/FbUI/Tabs'
import { SequencingSettings } from 'features/settings/components/SequencingSettings'
import { SenderEmailSettings } from 'features/settings/components/SenderEmailSettings'

const DEFAULT_TAB = 'sequencing'

const tabs = [
  { key: 'sequencing', title: 'Sequencing' },
  { key: 'email-outreach', title: 'Email Outreach' },
]

const validTabs = new Set(tabs.map((t) => t.key))

export function CampaignsSettingsPage() {
  const params = useParams()
  const navigate = useNavigate()
  const tab = params.tab ?? DEFAULT_TAB

  if (params.tab && !validTabs.has(params.tab)) {
    return <Navigate to={`/settings/campaigns/${DEFAULT_TAB}`} replace />
  }

  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0">
      <FBPageInnerTabsContainer>
        <Tabs
          tabs={tabs}
          selectedTab={tab}
          setSelectedTab={(value) => navigate(`/settings/campaigns/${value}`)}
          tabStyle={{ width: '150px' }}
        />
      </FBPageInnerTabsContainer>
      {tab === 'sequencing' && (
        <FBPageTableContainer>
          <SequencingSettings />
        </FBPageTableContainer>
      )}
      {tab === 'email-outreach' && (
        <FBPageTableContainer>
          <SenderEmailSettings />
        </FBPageTableContainer>
      )}
    </div>
  )
}
